/* eslint-disable @typescript-eslint/no-empty-function */
import { FormControlLabel, Grid, Switch } from '@mui/material'
import { NumberFieldC, TextFieldC } from 'components'
import { Controller, useFormContext } from 'react-hook-form'
import {
  calculeSalePrice,
  getAllowDecimalQuantity,
  normalizeQuantityInput,
  numberToQuantityString,
  stringToNumber
} from 'utils'
import BigNumber from 'bignumber.js'
import { useEffect } from 'react'
import { useResolveQuantityExpression } from 'modules/orders/hooks/useResolveQuantityExpression'
// import { ShowOrigin } from 'modules/orders/components/showOrigin'

export const ItemFormFields = (props: any) => {
  const {
    item = {},
    configurationFormValues,
    loadingPrice,
    isProductLoading = false,
    isTransfer = false,
    allowDecimalQuantity = false
    // canBeImported,
    // canBeImportedMessage
  } = props
  // const form = useItemFormDrawerStore.useForm()

  const { watch, setValue, control } = useFormContext()

  const [defaultPrice, defaultPrice4, currentPrice, quantityUn] = watch([
    'defaultPrice',
    'defaultPrice4',
    'currentPrice',
    'quantityUn'
  ])

  const handleSalePriceChange = (e: any) => {
    const salePrice = stringToNumber(e.target.value) || 0

    let discountVl: any = BigNumber(currentPrice || 0).minus(salePrice)

    let discountPerc: any = BigNumber(1)
      .minus(BigNumber(salePrice).div(currentPrice || 0))
      .times(100)

    discountVl =
      discountVl.toNumber() > 0 ? +discountVl.toNumber().toFixed(2) : 0

    discountPerc =
      discountPerc.toNumber() > 0 ? +discountPerc.toNumber().toFixed(2) : 0

    setValue('discount', discountVl)

    setValue('discountPercent', discountPerc)
  }

  const handleDiscountChange = (e: any) => {
    const discountVl = e?.target?.value || 0

    const salePriceVl = BigNumber(currentPrice || 0).minus(discountVl)

    const discountPerc = BigNumber(discountVl || 0)
      .div(currentPrice || 0)
      .times(100)

    setValue('salePrice', +salePriceVl.toNumber().toFixed(2))

    setValue('discountPercent', +discountPerc.toNumber().toFixed(2))
  }

  const handleDiscountPercentChange = (e: any) => {
    const value = e?.target?.value || 0

    const salePriceVl = calculeSalePrice(Number(value), currentPrice || 0)

    setValue('salePrice', +salePriceVl.toFixed(2))

    setValue(
      'discount',
      BigNumber(currentPrice || 0)
        .minus(salePriceVl.toFixed(2))
        .toNumber()
    )
  }

  const applySaleTypePrice = (newSaleType: string) => {
    const newPrice =
      newSaleType === '4' && Number(defaultPrice4) > 0
        ? defaultPrice4
        : defaultPrice

    setValue('currentPrice', newPrice || 0)
    setValue('salePrice', newPrice || 0)
    setValue('discount', 0)
    setValue('discountPercent', 0)
  }
  const hasConfiguration =
    !!item?.product?.id &&
    !!Object.keys(configurationFormValues || {}).length &&
    !!quantityUn
  const { data: resolvedQuantity } = useResolveQuantityExpression({
    productId: item?.product?.id || '',
    configurationFormValues: configurationFormValues || {},
    quantityUn: Number(stringToNumber(quantityUn)) || 0
  })

  useEffect(() => {
    if (hasConfiguration) {
      const qty = (resolvedQuantity as any)?.data?.quantity
      if (qty != null) {
        setValue('quantity', numberToQuantityString(Number(qty)))
      }
    } else {
      setValue('quantity', quantityUn)
    }
  }, [resolvedQuantity, hasConfiguration, quantityUn, setValue])

  const allowDecimal =
    isTransfer || allowDecimalQuantity || getAllowDecimalQuantity(item)

  const normalizeQuantityUn = (value: string) =>
    normalizeQuantityInput(value, allowDecimal)

  return (
    <Grid container>
      <Grid container spacing={2} item>
        {/* <ShowOrigin canBeImported={canBeImported}>
          <Grid item xs={12}>
            <SwitchC
              name="origin"
              label="ICMS 4%"
              disabled={canBeImportedMessage}
              error={
                canBeImportedMessage
                  ? `FCI não cadastrado, para habilitar "ICMS 4%" entre em contato com a equipe fiscal!`
                  : undefined
              }
            />
          </Grid>
        </ShowOrigin> */}
        {Number(defaultPrice4) > 0 && (
          <Grid item xs={12}>
            <Controller
              name="saleType"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Switch
                      checked={field.value === '4'}
                      onChange={(_, checked) => {
                        const newSaleType = checked ? '4' : '12'
                        field.onChange(newSaleType)
                        applySaleTypePrice(newSaleType)
                      }}
                      disabled={loadingPrice}
                    />
                  }
                  label="Venda a 4%"
                />
              )}
            />
          </Grid>
        )}
        <Grid item xs={6}>
          <NumberFieldC
            name="currentPrice"
            label="Preço Formado "
            prefix="R$ "
            disabled
            loading={loadingPrice}
          />
        </Grid>
        <Grid item xs={6}>
          <NumberFieldC
            name="salePrice"
            label="Preço Unitário"
            prefix="R$ "
            onChange={handleSalePriceChange}
            loading={loadingPrice && !watch('salePrice')}
            disabled={loadingPrice}
          />
        </Grid>
        <Grid item xs={6}>
          <TextFieldC
            name="quantityUn"
            label={`Quantidade (UN)`}
            disabled={
              // !!expressionNameId(item.product) ||
              loadingPrice || isProductLoading
            }
            normalize={normalizeQuantityUn}
          />
        </Grid>

        <Grid item xs={6}>
          <TextFieldC
            name="quantity"
            label={`Quantidade (${item?.product?.unitMeasure})`}
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <NumberFieldC
            name="discount"
            label={`Desconto`}
            prefix="R$ "
            onChange={handleDiscountChange}
            disabled={loadingPrice}
          />
        </Grid>
        <Grid item xs={6}>
          <NumberFieldC
            name="discountPercent"
            label={`Desconto`}
            suffix="%"
            onChange={handleDiscountPercentChange}
            disabled={loadingPrice}
          />
        </Grid>
        <Grid item xs={6}>
          <TextFieldC name="xPed" label="N° Ordem de Compra" />
        </Grid>
        <Grid item xs={6}>
          <TextFieldC name="nItemPed" label="Seq. Itens na OC" />
        </Grid>
        <Grid item xs={12}>
          <TextFieldC
            name="pcpObservation"
            label="Observação PCP"
            multiline
            rows={3}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
